import React, { useState, useEffect } from "react";
import api from "../../../api/axios";
import toast from "react-hot-toast";
import { Trash2, Filter, X, Image as ImageIcon } from "lucide-react";

const toAbsoluteImageUrl = (path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path) || path.startsWith("data:")) return path;

  const base = (process.env.REACT_APP_UPLOAD_URL || process.env.REACT_APP_BASE_URL || "").replace(/\/$/, "");
  const cleanPath = String(path).replace(/^\/+/, "");
  return base ? `${base}/${cleanPath}` : path;
};

export default function GaleriListPage() {
  const [images, setImages] = useState([]);
  const [tags, setTags] = useState([]);
  const [selectedTag, setSelectedTag] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const [imgRes, tagRes] = await Promise.all([
        api.get("/galeri"),
        api.get("/galeritag"),
      ]);
      const mappedImages = (imgRes.data || []).map((img) => ({
        ...img,
        imageUrl: toAbsoluteImageUrl(img.galeriImagePath || img.imagePath || img.imageUrl),
      }));
      setImages(mappedImages);
      setTags(tagRes.data || []);
    } catch { toast.error("Galeri yüklenemedi"); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchData(); }, []);

  const handleDelete = (id) => {
    if (!window.confirm("Bu görseli silmek istediğinize emin misiniz?")) return;
    api.delete(`/galeri/${id}`)
      .then(() => { toast.success("Görsel silindi"); fetchData(); })
      .catch(() => toast.error("Silme başarısız"));
  };

  const filtered = selectedTag
    ? images.filter((img) => String(img.galeriTagId) === selectedTag)
    : images;

  const selectedTagName = tags.find((t) => String(t.galeriTagId) === selectedTag)?.tagName;

  if (loading) return <div className="page-loading"><div className="loading-spinner" /><p>Yükleniyor...</p></div>;

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h2>Galeri</h2>
          <p className="page-subtitle">
            {filtered.length} / {images.length} görsel
            {selectedTagName ? ` • ${selectedTagName}` : ""}
          </p>
        </div>
        <div className="header-actions">
          <div className="filter-select gallery-filter-select">
            <Filter size={16} />
            <select value={selectedTag} onChange={(e) => setSelectedTag(e.target.value)} className="form-select">
              <option value="">Tümü</option>
              {tags.map((t) => <option key={t.galeriTagId} value={t.galeriTagId}>{t.tagName}</option>)}
            </select>
          </div>
          {selectedTag && (
            <button className="btn btn-ghost" onClick={() => setSelectedTag("")}>
              <X size={16} /> Temizle
            </button>
          )}
        </div>
      </div>

      <div className="gallery-grid">
        {filtered.map((img) => (
          <div key={img.galeriId} className="gallery-card">
            <div className="gallery-image">
              {img.imageUrl ? (
                <img
                  src={img.imageUrl}
                  alt={img.imageTitle || ""}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='450'%3E%3Crect width='600' height='450' fill='%23e2e8f0'/%3E%3C/svg%3E";
                  }}
                />
              ) : (
                <div className="gallery-image-fallback"><ImageIcon size={28} /></div>
              )}

              {img.tagName && <span className="gallery-tag-badge">{img.tagName}</span>}
              <div className="gallery-overlay">
                <button onClick={() => handleDelete(img.galeriId)} className="btn-icon delete">
                  <Trash2 size={18} />
                </button>
              </div>
            </div>
            <div className="gallery-info">
              <span className="gallery-title">{img.imageTitle || "Adsız"}</span>
              {!img.tagName && <span className="gallery-tag">Etiketsiz</span>}
            </div>
          </div>
        ))}
      </div>

      {filtered.length === 0 && (
        <div className="empty-state">
          <p>{selectedTag ? "Bu etikette görsel yok" : "Henüz görsel eklenmemiş"}</p>
        </div>
      )}
    </div>
  );
}
